import ApplicationSerializer from './application';

export default class GlobalPhotoPageSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key) {
    if (key === 'flows') {
      return 'global-flow';
    } else if (key === 'photo-pages') {
      return 'global-photo-page';
    } else {
      return super.modelNameFromPayloadKey(...arguments);
    }
  }

  payloadKeyFromModelName(modelName) {
    if (modelName === 'global-flow') {
      return 'flows';
    } else if (modelName === 'global-photo-page') {
      return 'photo-pages';
    } else {
      return super.payloadKeyFromModelName(...arguments);
    }
  }
}
